'use client';

import React from 'react';

export default function KnowledgeSection() {
  return (
    <div className="relative w-full bg-[#F7F7F8] py-24 rounded-3xl my-12 font-sans selection:bg-blue-100 border border-gray-200">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 gap-16 px-6 lg:grid-cols-[300px_1fr] items-start">
        
        {/* LEWA KOLUMNA - Elementy "Sticky" */}
        <div className="hidden lg:block relative h-full min-h-[600px]">
          
          {/* SZYNA (LINIA TŁA) */}
          <div className="absolute left-[50%] -translate-x-1/2 top-0 bottom-0 w-[1px] bg-gradient-to-b from-transparent via-blue-200 to-transparent -z-10"></div>
          
          {/* STICKY CONTAINER */}
          <div className="sticky top-32 flex flex-col items-center gap-6">
            
            {/* Karta 1: GOOGLE SEARCH CONSOLE */}
            <div className="relative z-10 w-64 rounded-xl bg-white p-0 shadow-[0_8px_30px_rgb(0,0,0,0.06)] border border-gray-200 overflow-hidden transition hover:scale-105 duration-300">
                <div className="bg-[#f1f3f4] px-4 py-3 border-b border-gray-200 flex items-center gap-2">
                    <div className="w-4 h-4 rounded-full bg-white border border-gray-300 flex items-center justify-center">
                        <div className="w-2 h-2 rounded-full bg-blue-500"></div>
                    </div>
                    <span className="text-[10px] font-medium text-gray-600">Google Search Console</span>
                </div>
                <div className="p-5 space-y-4">
                    <div className="flex items-center gap-2">
                        <div className="bg-green-100 text-green-700 p-1 rounded-full">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                        </div>
                        <div>
                            <div className="text-[11px] font-bold text-gray-800">URL is on Google</div>
                            <div className="text-[9px] text-gray-500">Indexing: Valid</div>
                        </div>
                    </div>
                    <div>
                        <div className="flex justify-between items-end mb-1">
                            <span className="text-[10px] text-gray-500">Impressions</span>
                            <span className="text-[10px] font-bold text-green-600">↑ 24.5%</span>
                        </div>
                        <div className="h-12 w-full flex items-end gap-1 opacity-90">
                            <div className="w-1/6 bg-blue-50 h-[30%] rounded-t-[1px]"></div>
                            <div className="w-1/6 bg-blue-100 h-[50%] rounded-t-[1px]"></div>
                            <div className="w-1/6 bg-blue-200 h-[40%] rounded-t-[1px]"></div>
                            <div className="w-1/6 bg-blue-300 h-[70%] rounded-t-[1px]"></div>
                            <div className="w-1/6 bg-blue-400 h-[60%] rounded-t-[1px]"></div>
                            <div className="w-1/6 bg-blue-600 h-[100%] rounded-t-[1px] relative">
                                <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-1.5 h-1.5 bg-green-500 rounded-full border border-white"></div>
                            </div>
                        </div>
                    </div>
                    <div className="bg-gray-50 rounded p-2 border border-gray-100">
                        <div className="text-[9px] font-bold text-gray-400 uppercase tracking-wider mb-1">Experience</div>
                        <div className="flex items-center justify-between text-[10px] mb-1">
                            <span className="text-gray-600">Mobile Usability</span>
                            <span className="text-green-600 font-bold">Good</span>
                        </div>
                        <div className="flex items-center justify-between text-[10px]">
                            <span className="text-gray-600">HTTPS</span>
                            <span className="text-green-600 font-bold">Valid</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Łącznik */}
            <div className="h-8 w-[1px] bg-blue-300/50 my-[-10px] relative z-0"></div>

            {/* Karta 2: Konfiguracja SEO (Snippet) */}
            <div className="relative z-10 w-56 rounded-xl bg-[#1e1e1e] p-4 shadow-lg border border-gray-700/50 text-gray-400 font-mono text-[10px] opacity-90 backdrop-blur-md">
                 <div className="flex items-center gap-2 mb-2 border-b border-gray-700 pb-2 text-[9px] font-sans font-bold text-gray-500 uppercase">
                    next-sitemap.config.js
                 </div>
                 <div className="space-y-1.5">
                    <div className="flex gap-2">
                        <span className="text-purple-400">module</span>.<span className="text-blue-400">exports</span> = {'{'}
                    </div>
                    <div className="pl-2 flex gap-2">
                        <span className="text-blue-300">siteUrl:</span> 
                        <span className="text-orange-300">'https://webpol.pl'</span>,
                    </div>
                    <div className="pl-2 flex gap-2">
                        <span className="text-blue-300">generateRobotsTxt:</span> 
                        <span className="text-yellow-300">true</span>,
                    </div>
                    <div className="pl-2 flex gap-2">
                         <span className="text-blue-300">exclude:</span> ['/admin/*'],
                    </div>
                    <div>{'}'}</div>
                 </div>
            </div>

          </div>
        </div>

        {/* PRAWA KOLUMNA - Główna treść */}
        <div className="flex flex-col gap-10 pb-12">
          
          {/* NAGŁÓWEK */}
          <div className="relative">
             <h2 className="text-4xl font-bold tracking-tight text-[#0b0c0e] md:text-5xl leading-[1.15]">
              Większość agencji <br />
              <span className="text-gray-400">nawet tego nie czyta.</span>
            </h2>
            <div className="absolute -top-6 right-6 md:right-auto md:left-[450px]">
                <div className="relative h-12 w-12 rounded-full border-[3px] border-white bg-gray-100 shadow-lg">
                    <img src="https://i.pravatar.cc/150?u=tech_lead_2" alt="Tech Lead" className="h-full w-full rounded-full object-cover"/>
                    <div className="absolute -bottom-1 -right-1 h-4 w-4 rounded-full bg-green-500 border-2 border-white"></div>
                </div>
            </div>
          </div>

          <div className="prose prose-lg text-gray-600 leading-relaxed max-w-3xl">
            <p className="font-medium text-gray-800 text-xl">
              Marketingowcy sprzedają marzenia. My sprzedajemy przewidywalną inżynierię.
            </p>
            <p className="mt-4">
              Podczas gdy konkurencja instaluje gotowe szablony i "ciężkie" wtyczki, my wracamy do fundamentów. 
              Tworzenie nowoczesnej strony internetowej to nie układanie klocków w wizualnym edytorze – to walka o milisekundy.
            </p>
          </div>

          {/* SYMULACJA EDYTORA */}
          <div className="relative group max-w-2xl mt-4">
            <div className="absolute -top-10 left-0 z-20 flex items-center gap-1 rounded-t-lg bg-[#1a1b1e] p-2 px-4 shadow-xl opacity-100 transition-opacity">
                <span className="text-[10px] text-gray-400 mr-3 font-mono">docs/core-web-vitals-2024.md</span>
                <div className="h-3 w-[1px] bg-white/20 mx-2"></div>
                <button className="p-1 text-white hover:bg-white/20 rounded"><BIcon /></button>
                <div className="h-3 w-3 rounded-full bg-green-500 border border-white/20 ml-3 shadow-[0_0_10px_rgba(34,197,94,0.5)]"></div>
            </div>

            <div className="relative rounded-lg rounded-tl-none bg-white p-8 shadow-sm border border-gray-200 text-lg text-gray-800 leading-relaxed hover:shadow-md transition-shadow duration-300">
              <span className="bg-[#ffeba8] px-1 py-0.5 rounded selection:bg-blue-200 font-medium">
                Google Search Essentials
              </span> nie pozostawia złudzeń: szybkość ładowania to dopiero początek. 
              W 2024 roku kluczowy jest wskaźnik <span className="font-mono text-sm bg-purple-50 text-purple-600 px-1 border border-purple-100 rounded">INP (Interaction to Next Paint)</span>. 
              
              <br /><br />
              Strony budowane na gotowcach często ładują dziesiątki niepotrzebnych skryptów, blokując główny wątek przeglądarki. 
              Dla nas <span className="font-mono text-sm bg-red-50 text-red-600 px-1 border border-red-100 rounded">hydration errors</span> czy layout shifts (CLS) są niedopuszczalne.
              <span className="inline-block w-[2px] h-5 bg-black animate-pulse align-middle ml-1"></span>
            </div>
          </div>

          {/* DŁUG TECHNICZNY */}
          <div className="flex flex-col gap-4 border-l-4 border-gray-200 pl-6 py-2 max-w-3xl">
             <h3 className="text-xl font-bold text-gray-900">Ukryty koszt tanich rozwiązań</h3>
             <p className="text-gray-600 text-lg">
                Gotowe motywy to tzw. <span className="text-gray-900 font-semibold">dług techniczny</span> zaciągnięty na starcie. 
                Nasze rozwiązania "custom" są wolne od zbędnego balastu.
             </p>
          </div>

          {/* CHECKLISTA I WYKRES */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mt-2">
            
            {/* Karta 1: Checklista */}
            <div className="rounded-xl bg-white p-6 border border-gray-200 shadow-sm relative overflow-hidden group hover:border-blue-300 transition-colors">
                <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition">
                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" className="text-blue-600"><path d="M9 11l3 3L22 4"></path><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
                </div>
                <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-5">Nasz Standard Wdrożenia</h3>
                <ul className="space-y-4">
                    <li className="flex items-start gap-3 text-sm text-gray-700">
                        <div className="flex h-5 w-5 mt-0.5 items-center justify-center rounded bg-blue-100 text-blue-600 shrink-0">
                             <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4"><path d="M20 6L9 17l-5-5"></path></svg>
                        </div>
                        <div>
                            <strong className="text-gray-900">Semantyczny HTML5</strong>
                            <p className="text-gray-500 text-xs mt-0.5">Lepsze SEO i dostępność dla czytników.</p>
                        </div>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-gray-700">
                        <div className="flex h-5 w-5 mt-0.5 items-center justify-center rounded bg-blue-100 text-blue-600 shrink-0">
                             <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4"><path d="M20 6L9 17l-5-5"></path></svg>
                        </div>
                        <div>
                            <strong className="text-gray-900">Schema.org JSON-LD</strong>
                            <p className="text-gray-500 text-xs mt-0.5">Komunikacja z botami Google.</p>
                        </div>
                    </li>
                    <li className="flex items-start gap-3 text-sm text-gray-700">
                        <div className="flex h-5 w-5 mt-0.5 items-center justify-center rounded bg-blue-100 text-blue-600 shrink-0">
                             <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="4"><path d="M20 6L9 17l-5-5"></path></svg>
                        </div>
                        <div>
                            <strong className="text-gray-900">Zero Vulnerabilities</strong>
                            <p className="text-gray-500 text-xs mt-0.5">Bezpieczeństwo bez wtyczek.</p>
                        </div>
                    </li>
                </ul>
            </div>

            {/* Karta 2: Analityka */}
            <div className="rounded-xl bg-[#0F1115] p-6 border border-gray-800 shadow-xl text-white relative overflow-hidden">
                 <div className="absolute -right-10 -top-10 w-32 h-32 bg-green-500/20 blur-3xl rounded-full"></div>
                 <div className="flex justify-between items-start mb-8 relative z-10">
                    <div>
                        <div className="text-xs text-gray-400 mb-1 uppercase tracking-wider">Mobile Performance</div>
                        <div className="text-4xl font-bold text-white tracking-tight">99<span className="text-lg text-gray-500 font-normal">/100</span></div>
                    </div>
                    <div className="h-10 w-10 rounded-full bg-green-500/10 border border-green-500/20 flex items-center justify-center text-green-400">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"></path></svg>
                    </div>
                 </div>
                 <div className="flex items-end gap-2 h-24 w-full opacity-90 relative z-10">
                    <div className="w-1/5 bg-gray-800 h-[30%] rounded-t-sm"></div>
                    <div className="w-1/5 bg-gray-700 h-[50%] rounded-t-sm"></div>
                    <div className="w-1/5 bg-gray-600 h-[40%] rounded-t-sm"></div>
                    <div className="w-1/5 bg-gray-500 h-[70%] rounded-t-sm"></div>
                    <div className="w-1/5 bg-gradient-to-t from-green-600 to-green-400 h-[90%] rounded-t-sm shadow-[0_0_20px_rgba(34,197,94,0.4)] relative">
                         <div className="absolute -top-6 left-1/2 -translate-x-1/2 text-[10px] font-bold bg-white text-black px-1.5 rounded">MY</div>
                    </div>
                 </div>
            </div>
          </div>

          <p className="text-sm text-gray-400 italic">
            *Fragment rzeczywistej konfiguracji SEO, którą wdrażamy standardowo.
          </p>

        </div>
      </div>
    </div>
  );
}

// IKONA
function BIcon() { return <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3"><path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path></svg> }